import { combineReducers } from '@reduxjs/toolkit';
import userStore from '../stores/user/user.store';
import navigationStore from '../stores/navigation/navigation.store';
import languageStore from '../stores/language/language.store';
import enumStore from '../stores/allEnums/allEnums.store';
import menuStore from '../stores/user/menu.store';
import permissionsStore from '../stores/user/permission.store';
import themeStore from '../stores/theme/theme.store';

const rootReducer = combineReducers({
  user: userStore.reducer,
  menu: menuStore.reducer,
  permissions: permissionsStore.reducer,
  navigation: navigationStore.reducer,
  langReducer: languageStore.reducer,
  enumsReducer: enumStore.reducer,
  theme: themeStore.reducer,
});

export default rootReducer;

